// Labels the admin pages and the API's Telegram feeds (apps/api/src/lib/telegram-feed.ts) both show.
// cms_commands.sourceType: which screen or flow created the command
export const COMMAND_SOURCE = {
    'admin.adjust': 'Cộng / trừ tiền tay', 'admin.lock': 'Khóa / mở khóa', 'bets.edit': 'Sửa kết quả', 'campaign.claim': 'Nhận thưởng sự kiện',
    'games.ban_ca': 'Bắn Cá', 'jackpots.rules': 'Luật hũ', 'games.control': 'Quỹ và bot', 'games.bots': 'Bot', 'jackpots': 'Hũ', 'games.force': 'Đặt kết quả', 'games.poker': 'Đặt kết quả poker', 'games.limits': 'Hạn mức cược', 'games.rtp': 'RTP game', 'games.nhip': 'Nhịp Tài Xỉu', 'games.safety': 'An toàn game', 'games.visibility': 'Ẩn hiện game',
    'player.flag.rut': 'Dừng rút', 'player.flag.chat': 'Cấm chat', 'chat.mute': 'Cấm chat từ nhật ký chat', 'chat.delete': 'Xóa tin chat', 'chat.send': 'Tin hệ thống vào chat', 'chat.banned': 'Từ cấm chat', 'player.flag.game': 'Khóa game',
    'player.password.login': 'Đặt lại mật khẩu đăng nhập', 'player.password.login_set': 'Đặt mật khẩu đăng nhập', 'player.password.withdraw': 'Xóa mật khẩu rút', 'player.password.withdraw_set': 'Đặt mật khẩu rút',
    'risk.hold': 'Giữ rút (quy tắc rủi ro)', 'risk.release': 'Mở rút (hàng chờ rủi ro)', 'risk.config': 'Chống gian lận',
    'comp.batch': 'Đền bù hàng loạt', 'giftcode.redeem': 'Nhập giftcode', 'live.refund': 'Hoàn cả ván', 'site.switch': 'Công tắc hệ thống', 'wallet.deposit': 'Duyệt nạp', 'wallet.nap': 'Nạp từ sảnh', 'wallet.refund': 'Hoàn rút', 'wallet.hold': 'Giữ tiền rút', 'agent.transfer': 'Chuyển tiền đại lý',
    'lode.draw': 'Kỳ quay lô đề', 'lode.ticket': 'Hoàn vé lô đề', 'lode.ty_le': 'Tỷ lệ trả lô đề', 'lode.gioi_han': 'Số chặn và trần số lô đề',
    'vip.reward': 'Thưởng VIP', 'vip.push': 'Điểm VIP',
};
// Audit action codes; later modules add theirs here. Unknown codes are shown as they are.
export const AUDIT_ACTION = {
    'admin.login': 'Đăng nhập',
    'risk.resolve': 'Xử lý mục rủi ro',
    'admin.login.failed': 'Đăng nhập thất bại',
    'admin.logout': 'Đăng xuất',
    'admin.create': 'Tạo quản trị viên',
    'admin.update': 'Sửa quản trị viên',
    'admin.reset_credentials': 'Cấp lại mật khẩu và 2FA',
    'admin.change_password': 'Đổi mật khẩu',
    'role.update': 'Sửa quyền vai trò',
    'settings.update': 'Đổi cài đặt',
    'export.csv': 'Xuất CSV',
    'alert.ack': 'Đánh dấu đã xem thắng lớn',
    'user.kick': 'Đăng xuất người chơi khỏi game',
    'user.kick_lobby': 'Kick người chơi về sảnh',
    'user.risk.marks': 'Đổi cờ rủi ro người chơi',
    'user.note': 'Ghi chú người chơi',
    'command.player_flag.create': 'Tạo lệnh hạn chế người chơi',
    'command.password.create': 'Tạo lệnh đặt lại mật khẩu',
    'live.kick': 'Đuổi người chơi khỏi một game',
    'command.money.create': 'Tạo lệnh tiền',
    'command.lock.create': 'Tạo lệnh khóa tài khoản',
    'command.config.create': 'Tạo lệnh cấu hình',
    'command.result.create': 'Tạo lệnh đặt kết quả',
    'command.edit.create': 'Tạo lệnh sửa kết quả',
    'command.approve': 'Duyệt lệnh',
    'command.reject': 'Từ chối lệnh',
    'command.succeeded': 'Hệ A thực hiện xong',
    'command.failed': 'Hệ A từ chối thực hiện',
    'vip.config.update': 'Đổi cấu hình VIP',
    'vip.adjust': 'Điều chỉnh điểm / cấp VIP',
    'vip.reward.submit': 'Gửi duyệt thưởng VIP',
    'vip.reward.pay': 'Chi thưởng VIP',
    'vip.reward.approve': 'Duyệt chi thưởng VIP',
    'vip.reward.reject': 'Từ chối thưởng VIP',
    'agent.activate': 'Kích đại lý',
    'agent.rate': 'Đổi tỷ lệ đại lý',
    'agent.status': 'Đổi trạng thái đại lý',
    'agent.bind': 'Gắn thành viên đại lý',
    'agent.payout.approve': 'Duyệt chi hoa hồng',
    'agent.payout.reject': 'Từ chối chi hoa hồng',
    'agent.payout.pay': 'Xác nhận đã chuyển hoa hồng',
    'wallet.approve': 'Duyệt nạp / rút',
    'wallet.reject': 'Từ chối nạp / rút',
    'wallet.pay': 'Xác nhận đã chuyển tiền rút',
    'wallet.reset_withdraw_password': 'Xóa mật khẩu rút của người chơi',
    'user.withdraw_password_set': 'Đặt mật khẩu rút của người chơi',
    'user.login_password_set': 'Đặt mật khẩu đăng nhập của người chơi',
    'giftcode.create': 'Tạo giftcode',
    'giftcode.batch.create': 'Tạo lô giftcode',
    'giftcode.update': 'Sửa giftcode',
    'giftcode.batch.update': 'Sửa lô giftcode',
    'campaign.create': 'Tạo sự kiện / nhiệm vụ',
    'campaign.update': 'Sửa sự kiện / nhiệm vụ',
    'campaign.delete': 'Xóa sự kiện / nhiệm vụ',
    'inbox.send': 'Gửi hộp thư',
    'support.reply': 'Trả lời phiếu hỗ trợ',
    'support.reply.retry': 'Gửi lại tin hỗ trợ',
    'support.assign': 'Giao phiếu hỗ trợ',
    'support.close': 'Đóng phiếu hỗ trợ',
    'support.reopen': 'Mở lại phiếu hỗ trợ',
    'support.link': 'Gắn người chơi vào phiếu hỗ trợ',
    'support.canned.create': 'Tạo câu trả lời mẫu',
    'support.canned.update': 'Sửa câu trả lời mẫu',
    'support.bot.update': 'Đổi cài đặt bot hỗ trợ',
    'comp.create': 'Tạo đợt đền bù',
    'comp.approve': 'Duyệt đợt đền bù',
    'comp.reject': 'Từ chối đợt đền bù',
    'inbox.update': 'Sửa hạn hộp thư',
    'inbox.recall': 'Thu hồi hộp thư',
    'command.flag.create': 'Tạo lệnh cờ người chơi',
    'command.refund.create': 'Tạo lệnh hoàn tiền',
    'command.transfer.create': 'Tạo lệnh chuyển tiền',
    'command.jackpot.create': 'Tạo lệnh hũ',
    'command.chat_delete.create': 'Tạo lệnh xóa tin chat',
    'command.chat_send.create': 'Tạo lệnh gửi tin chat hệ thống',
    'command.cooloff.create': 'Tạo lệnh tự khóa',
    'command.lode.create': 'Tạo lệnh lô đề',
    'command.vip.create': 'Tạo lệnh VIP',
    'agents.commission.switch': 'Bật / tắt hoa hồng theo game, sảnh',
    'campaign.claim': 'Nhận thưởng sự kiện',
    'content.banner.upload': 'Tải ảnh banner',
    'content.notice.push': 'Gửi thông báo vào game',
    'crm.settings.update': 'Đổi cài đặt CRM',
    'marketing.create': 'Thêm chi phí marketing',
    'marketing.update': 'Sửa chi phí marketing',
    'marketing.delete': 'Xóa chi phí marketing',
    'ops.telegram_test': 'Gửi tin Telegram thử',
    'pii.reveal': 'Xem số đầy đủ (tài khoản, điện thoại)',
    'recon.run': 'Chạy đối soát',
    'recon.ack': 'Xác nhận chênh lệch đối soát',
    'risk.ack': 'Đánh dấu đã xem mục rủi ro',
    'risk.block.add': 'Thêm vào danh sách chặn',
    'risk.block.remove': 'Gỡ khỏi danh sách chặn',
    'segment.create': 'Tạo nhóm người chơi',
    'segment.update': 'Sửa nhóm người chơi',
    'segment.delete': 'Xóa nhóm người chơi',
    'user.bank.unlink': 'Gỡ liên kết ngân hàng của người chơi',
    'user.bank.verify': 'Xác minh tài khoản ngân hàng của người chơi',
    'user.bank.unverify': 'Bỏ xác minh tài khoản ngân hàng của người chơi',
    'user.coolOff': 'Đặt tự khóa cho người chơi',
    'user.coolOff.lift': 'Gỡ hoặc rút ngắn tự khóa',
    'wallet.account.retire': 'Ngừng tài khoản nhận tiền',
    'wallet.account.restore': 'Dùng lại tài khoản nhận tiền',
    'wallet.bank_tx.match': 'Khớp giao dịch ngân hàng với lệnh nạp',
    'wallet.bank_tx.dismiss': 'Bỏ qua giao dịch ngân hàng',
    'wallet.statement_import': 'Nhập sao kê ngân hàng',
};
//# sourceMappingURL=labels.js.map